import { useEffect, useState } from 'react';

import {
  getWindowRuntimeConfig,
  loadPositionsAclRuntimeConfig,
} from './runtimeConfig';

const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

export function isPositionsAclRedactedCellEnabled(
  env: Record<string, string | undefined> = process.env,
): boolean {
  const runtimeConfig = getWindowRuntimeConfig();
  if (runtimeConfig) {
    return runtimeConfig.positionsAclRedactedCellEnabled;
  }

  if (env.NODE_ENV === 'production') {
    return false;
  }

  return TRUE_VALUES.has(
    String(env.REACT_APP_POSITIONS_ACL_REDACTED_CELL_ENABLED ?? '')
      .trim()
      .toLowerCase(),
  );
}

export function usePositionsAclRedactedCellEnabled(): boolean {
  const [enabled, setEnabled] = useState(() => isPositionsAclRedactedCellEnabled());

  useEffect(() => {
    if (getWindowRuntimeConfig()) {
      return undefined;
    }

    let active = true;

    loadPositionsAclRuntimeConfig().then((config) => {
      if (active) {
        setEnabled(config.positionsAclRedactedCellEnabled);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return enabled;
}
